import facebook from '../../../../assets/socialIcons/facebook.png';

const Channel = () => {
  return (
    <div className="border bg-white flex justify-between items-center p-5 space-x-3 w-[40%] rounded-lg">
      <div className="flex items-center space-x-3">
        <img src={facebook} className="w-10 h-10" alt="facebook icon" />
        <div className="flex flex-col">
          <p className="flex items-center text-lg font-semibold">
            Facebook
            <span className="text-blue-800 text-[10px] pl-4">
              20 Post Remaining
            </span>
          </p>
          <p className="text-sm">Sharing Post To Your Facebook Page</p>
        </div>
      </div>
      <button className=" text-red-500">Disconnect</button>
    </div>
  );
};

export default Channel;
